import { gsap, Power3, Power2 } from "gsap";
import BezierEasing from 'bezier-easing';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class NotFound extends NoScroll {
  sliderDom;
  scroller;
  items = [];

  constructor() {
    super();

    this.sliderDom = GetBy.class('__slider', this.container)[0];
    this.items = GetBy.selector('[scroll-infinity-item]', this.container);

    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
      domResize: this.sliderDom,
      container: this.sliderDom,
      multiplicator: 1,
      itemClass: NotFound__Item,
      // minSpeed: .2,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true
    });
    this.scroller.directGoto(6);
  }

  afterShow() {
    super.afterShow();

    this.scroller.show();
    // this.scroller.start();
    this.scroller.goto(1.5);
  }

  beforeHide() {
    super.beforeHide();
    this.scroller.stop();
  }

  loop() {
    super.loop();
    this.scroller.loop();

  }

  dispose() {
    this.scroller.dispose();
    super.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    this.scroller.resize();
  }
}

ControllerPage._addPage('not-found', NotFound);

class NotFound__Item extends InfiniteScroll__Item {
  icon = GetBy.class('icon', this.dom)[0];

  constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
    super(__d, __i, __axis, true);

    gsap.set(this.icon, { opacity: 0 });
  }

  show() {
    super.show();

    gsap.to(this.icon, {
      opacity: 1,
      duration: .5,
      ease: Power3.easeOut,
      delay: .05 * this.index
    });
  }

}
